// common/components/AuthRedirect.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const AuthRedirect = ({ children }) => {
  if (localStorage.getItem('token')) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AuthRedirect;